export var ModeOfTransport;
(function (ModeOfTransport) {
    ModeOfTransport["TRAIN"] = "TRAIN";
    ModeOfTransport["TRUCK"] = "TRUCK";
    ModeOfTransport["SHIP"] = "SHIP";
    ModeOfTransport["AIRPLANE"] = "AIRPLANE";
    ModeOfTransport["WALKING_AND_MOTORBIKE"] = "WALKING_AND_MOTORBIKE";
    ModeOfTransport["OTHER"] = "OTHER";
})(ModeOfTransport || (ModeOfTransport = {}));
